// extracted by mini-css-extract-plugin
module.exports = {"content":"sectionContent_content__QXCpK","stories":"sectionContent_stories__W3Xzl","placeholder":"sectionContent_placeholder__vjwSG","divider":"sectionContent_divider__hg5Ik"};